/// <reference path="../../typings/tsd.d.ts" /> 

module warsApp.services {

    export class EditableContentPageService extends HttpHandlerService {

        constructor($http: ng.IHttpService) {
            super($http);
        }

        public getEditiableContentPage(id: string): ng.IPromise<Wars.Domain.Model.Dtos.EditableContentPageDto> {
            var params: any = {};
            this.handlerUrl = "api/EditableContentPage/Edit/GetEditableContentPage?id=" + id;
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.EditableContentPageDto) => {
                    return result;
                });
        }

        public getEditableContentPageForView(id: string): ng.IPromise<Wars.Domain.Model.Dtos.EditableContentPageDto> {
            var params: any = {};
            this.handlerUrl = "api/EditableContentPage/View/GetEditableContentPageForView?id=" + id;
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.EditableContentPageDto) => {
                    return result;
                });
        }

        public updateEditableContentPage(contentPage: Wars.Domain.Model.Dtos.EditableContentPageDto): ng.IPromise<Wars.Domain.Model.Dtos.EditableContentPageDto> {
            var params = contentPage;
            this.handlerUrl = "api/EditableContentPage/UpdateEditableContentPage";
            return this.usePostHandler(params);
        }
    }
}

warsApp.registerService('EditableContentPageService', ['$http'])